angular.module('webtrader').component('totals', {
  templateUrl: (Account) => {
    if(Account.info.group.is_options)
      return BASE_URL+'templates/component.totalsOptions.html'
    return BASE_URL+'templates/component.totals.html'
  },
  controller: function (Account, Trades) {
    this.account = Account
    this.trades = Trades
  }
})
